var Flowcor = Flowcor || {};

Flowcor.MasonryGrid = function() {

  var _grid = '.masonry-grid';
  var _gridItem = '.masonry-grid .masonry-grid-item';
  var _columnSizer = '.masonry-grid .masonry-column-sizer';
  var _gutterSizer = '.masonry-grid .masonry-gutter-sizer';

  var _init = function() {
    $(_grid).isotope({
      layoutMode: 'packery',
      percentPosition: true,
      itemSelector: _gridItem,
      packery: {
        columnWidth: _columnSizer,
        gutter: _gutterSizer
      }
    });
  }

  /** PUBLIC API **/
  return {
    init : function() {return _init();}
  };

}();

$(function() {
  Flowcor.MasonryGrid.init();
});

